import { render } from "./admin-post-list.vue?vue&type=template&id=732c62f7"
import script from "./admin-post-list.vue?vue&type=script&lang=js"
export * from "./admin-post-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__